import {
  ActionReducerMapBuilder,
  CreateSliceOptions,
  createSlice
} from '@reduxjs/toolkit'
import { ledgerReportActions, ledgerReportClearActions } from './Actions'
import { SLICE_NAME } from './Selectors'
import {
  _floor,
  _forEach,
  _get,
  _groupBy,
  _mapValues,
  _set,
  _sortBy
} from '~/src/Utils/lodash'
export interface LedgerReportStore {
  loading: boolean
  report: any
  error: any
}
const INITIAL_STATE: LedgerReportStore = {
  loading: false,
  report: {},
  error: { code: 0, message: '', isDispatch: false }
}

const sliceOptions: CreateSliceOptions = {
  name: SLICE_NAME,
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<any>): void => {
    builder.addCase(ledgerReportActions.success, (state, { payload }) => {
      const generateed = generateData(payload)
      state.report = generateed
    })
    builder.addCase(ledgerReportClearActions, state => {
      state.report = {}
    })
  }
}

const ledgerReportSlice = createSlice(sliceOptions)
export default ledgerReportSlice.reducer

function generateData(data: any) {
  let { ledger, openingBalance } = data
  let groupedLedger = {}
  if (ledger) {
    ledger = ledger.map(_sanitizeLedgerItem)
    _forEach(
      _sortBy(ledger, ['transactionDate']).reverse(),
      (ledgerItem: any) => {
        const { transactionType } = ledgerItem
        const key = transactionType
        const temp = _get(groupedLedger, key) || []
        if (transactionType === 'C') {
          openingBalance += ledgerItem.creditAmount || 0
        }
        if (transactionType === 'D') {
          openingBalance -= ledgerItem.debitAmount || 0
        }
        temp.push({
          ...ledgerItem,
          runningBalance: _floor(openingBalance, 2)
        })
        _set(groupedLedger, key, temp)
      }
    )
  }
  return { ...data, ledger: groupedLedger }
}

function _sanitizeLedgerItem(ledgerItem: any) {
  const { transactionDate } = ledgerItem
  return { ...ledgerItem, transactionDate: new Date(transactionDate) }
}
